import { createContext } from 'react';

/**
 * @typedef {Object} ModalDefinition
 * @property {string} name - Unique name for tracking/identification
 * @property {string} [title] - Translation key for the modal title
 * @property {React.ComponentType} component - The React component to render inside the modal
 * @property {boolean} [hideCloseButton] - Whether to hide the close button
 */

/**
 * @typedef {Object} ModalEntry
 * @property {string} name
 * @property {string} [title]
 * @property {React.ComponentType} component
 * @property {boolean} [hideCloseButton]
 * @property {*} [closeData] - Data to pass to onCloseCallback when this modal
 *   is dismissed via the shared close (X) button, which doesn't go through
 *   the component's own closeModal prop. Set via updateModal({ closeData })
 *   ahead of time when a modal needs its eventual close to carry state.
 * @property {*} data - Data passed to the modal component
 * @property {Function|null} onCloseCallback - Callback invoked when modal closes
 * @property {'mounting'|'entering'|'open'|'exiting'} animationState - Current animation phase
 */

const ModalContext = createContext(undefined);

export default ModalContext;
